var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgResetColumns = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3,20.3l-0.2,0.3c-0.4,0.5-1.2,0.6-1.7,0.2L1.8,5.4C1.3,5,1.2,4.2,1.7,3.7l0.2-0.3c0.4-0.5,1.2-0.6,1.7-0.2l18.5,15.4 C22.7,19,22.8,19.8,22.3,20.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,6.2c0-1.2-1-2.2-2.2-2.2h-1c-1.2,0-2.2,1-2.2,2.2v0.3c0,0.1,0,0.1,0.1,0.1l5,4.1c0.1,0.1,0.3,0,0.3-0.1 V6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,6.2C22,5,21,4,19.8,4h-1c-1.2,0-2.2,1-2.2,2.2v6.4c0,0.1,0,0.1,0.1,0.1l5,4.1c0.1,0.1,0.3,0,0.3-0.1V6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,17.8c0,1.2,1,2.2,2.2,2.2h1c1.2,0,2.2-1,2.2-2.2v-0.3c0-0.1,0-0.1-0.1-0.1l-5-4.1c-0.1-0.1-0.3,0-0.3,0.1 V17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,17.8C2,19,3,20,4.2,20h1.1c1.1,0,2-0.9,2-2v-6.6c0-0.1,0-0.1-0.1-0.1l-5-4.1C2.2,7.1,2,7.1,2,7.3V17.8z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResetColumns);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reset-columns.84eb4dbb3dfb463bf47f31c4afeb6119.svg";